import { printCalculatorForm } from "@Broker/@Modules/financial-tools/api/financial-tools-api";
import { CALCULATOR_FORMS } from "@Broker/@Types/financial-tools/types";
import { openFileDialog } from "@Shared/@Utils/utils";
export const PRINT_PAYMENT_ANALYZER_FORM = "PRINT_PAYMENT_ANALYZER_FORM",
  PRINT_MAXIMUM_MORTGAGE_FORM = "PRINT_MAXIMUM_MORTGAGE_FORM",
  PRINT_MINIMUM_INCOME_FORM = "PRINT_MINIMUM_INCOME_FORM",
  PRINT_SCENARIO_BUILDER_FORM = "PRINT_SCENARIO_BUILDER_FORM",
  PRINT_PREPAYMENT_ANALYZER_FORM = "PRINT_PREPAYMENT_ANALYZER_FORM",
  PRINT_MORTGAGE_ISOLATOR_FORM = "PRINT_MORTGAGE_ISOLATOR_FORM";
export const defaultPrintAction = async content => {
  const printResponse = await printCalculatorForm(content);
  openFileDialog(printResponse == null ? void 0 : printResponse.s3PresignedUrl, content.type, {
    newWindow: true
  });
};
const actions = {
  [PRINT_PAYMENT_ANALYZER_FORM]: async (_context, {
    data
  }) => await defaultPrintAction({
    type: CALCULATOR_FORMS.PAYMENT_ANALYZER,
    data
  }),
  [PRINT_MAXIMUM_MORTGAGE_FORM]: async (_context, {
    data
  }) => await defaultPrintAction({
    type: CALCULATOR_FORMS.MAXIMUM_MORTGAGE,
    data
  }),
  [PRINT_MINIMUM_INCOME_FORM]: async (_context, {
    data
  }) => await defaultPrintAction({
    type: CALCULATOR_FORMS.MINIMUM_INCOME,
    data
  }),
  [PRINT_SCENARIO_BUILDER_FORM]: async (_context, {
    data
  }) => await defaultPrintAction({
    type: CALCULATOR_FORMS.SCENARIO_BUILDER,
    data
  })
};
export default actions;